'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reselect = require('reselect');

var _humanTime = require('human-time');

var _humanTime2 = _interopRequireDefault(_humanTime);

var _recompose = require('recompose');

var _navigationActions = require('../../../../../reducers/navigationActions');

var _modifiedBoardUtil = require('./modifiedBoardUtil');

var _ModifiedBoardActivity = require('./ModifiedBoardActivity');

var _ModifiedBoardActivity2 = _interopRequireDefault(_ModifiedBoardActivity);

var _BoardPopupListItem = require('../../../../../components/popupPanel/types/listItems/BoardPopupListItem');

var _BoardPopupListItem2 = _interopRequireDefault(_BoardPopupListItem);

var _notificationConstants = require('../../../../../../common/notifications/notificationConstants');

require('./ModifiedBoardMessage.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Constants


// Components


// Actions
// Lib
var modifiedBoardSelector = (0, _reselect.createSelector)(function (state, ownProps) {
    return ownProps.notification;
}, function (state, ownProps) {
    return state.getIn(['elements', ownProps.notification.get('id')]);
}, function (state, ownProps) {
    return state.get('users');
}, function (state, ownProps) {
    return state.getIn(['app', 'currentUser']);
}, function (state, ownProps) {
    return ownProps.active;
}, function (notification, board, users, currentUser, active, boardLinkId) {
    var notificationUsers = notification.get('children').map(function (child) {
        return child.get('modifiedBy');
    }).filter(function (child, index, self) {
        return self.indexOf(child) === index;
    }).filter(function (userId) {
        return userId !== currentUser.get('_id');
    }).reduce(function (acc, userId) {
        var user = users.get(userId);
        if (user) acc.push(user);

        return acc;
    }, []);

    return {
        board: board,
        users: notificationUsers,
        isNew: active && currentUser.get('lastCheckedNotifications') < notification.get('modifiedTime')
    };
});

// Styles


var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        dispatchNavigate: function dispatchNavigate(_ref) {
            var boardId = _ref.boardId,
                filter = _ref.filter;
            return dispatch((0, _navigationActions.navigateToBoard)({ boardId: boardId, filter: filter }));
        }
    };
};

var navigationHandlers = {
    navigateToLinkedBoard: function navigateToLinkedBoard(props) {
        return function (event) {
            event.preventDefault();
            var notification = props.notification,
                dispatchNavigate = props.dispatchNavigate;


            dispatchNavigate({
                boardId: notification.get('id'),
                filter: (0, _modifiedBoardUtil.getMessageFilter)(notification)
            });
        };
    }
};

var ModifiedBoardTimestampComponent = function ModifiedBoardTimestampComponent(_ref2) {
    var modifiedTime = _ref2.modifiedTime,
        notification = _ref2.notification;
    return _react2.default.createElement(
        'span',
        null,
        notification.get('message') === _notificationConstants.MODIFIED_ELEMENTS_BOARD_MESSAGES.INVITED ? _react2.default.createElement(
            'span',
            null,
            'Invited '
        ) : _react2.default.createElement(
            'span',
            null,
            'Updated '
        ),
        _react2.default.createElement(
            'span',
            { title: modifiedTime },
            (0, _humanTime2.default)(modifiedTime)
        )
    );
};

ModifiedBoardTimestampComponent.propTypes = {
    modifiedTime: _propTypes2.default.object.isRequired,
    notification: _propTypes2.default.object.isRequired
};

var ModifiedBoardMessage = function ModifiedBoardMessage(props) {
    var notification = props.notification,
        board = props.board,
        users = props.users,
        navigateToLinkedBoard = props.navigateToLinkedBoard,
        active = props.active,
        isNew = props.isNew;


    var modifiedTime = new Date(notification.get('modifiedTime'));

    var linkURL = null;
    if (board && users.length) {
        linkURL = (0, _modifiedBoardUtil.getMessageURL)(notification);
    }

    return _react2.default.createElement(_BoardPopupListItem2.default, {
        className: 'ModifiedBoardMessage',
        board: board,
        users: users,
        active: active,
        isNew: isNew,
        navigateToLinkedBoard: navigateToLinkedBoard,
        linkURL: linkURL,
        modifiedTime: modifiedTime,
        notification: notification,
        TimestampComponent: ModifiedBoardTimestampComponent,
        ActivityComponent: _ModifiedBoardActivity2.default });
};

ModifiedBoardMessage.propTypes = {
    notification: _propTypes2.default.object,
    board: _propTypes2.default.object,
    users: _propTypes2.default.array,
    navigateToLinkedBoard: _propTypes2.default.func,
    lastSeenDate: _propTypes2.default.number,
    active: _propTypes2.default.bool,
    isNew: _propTypes2.default.bool
};

var enhance = (0, _recompose.compose)((0, _reactRedux.connect)(modifiedBoardSelector, mapDispatchToProps), (0, _recompose.withHandlers)(navigationHandlers));

exports.default = enhance(ModifiedBoardMessage);


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/notifications/modifiedBoard/ModifiedBoardMessage.js
// module id = 2188
// module chunks = 0